const copyBtns = document.querySelectorAll('.a2a_button_copy_link');

copyBtns.forEach(btn => {
  const textEl = btn.querySelector('.a2a_text');

  if (textEl) {
    btn.originalText = textEl.textContent || '';
  }

  btn.addEventListener('click', event => {
    event.preventDefault();

    if (!navigator.clipboard) return;

    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        if (textEl) {
          const width = textEl.offsetWidth;
          textEl.style.minWidth = `${width}px`;
        }

        btn.classList.add('is-copy');

        if (textEl && btn.dataset.copied) {
          textEl.textContent = btn.dataset.copied;
        }

        if (btn.timer) clearTimeout(btn.timer);

        btn.timer = setTimeout(() => {
          if (textEl) {
            textEl.textContent = btn.originalText;

            requestAnimationFrame(() => {
              textEl.style.minWidth = '';
            });
          }

          btn.classList.remove('is-copy');
          btn.timer = null;
        }, 1000);
      })
      .catch(err => {
        console.error('Помилка при копіюванні:', err);
      });
  });
});
